import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HelperService } from '../../services/helper.service';
@Component({
  selector: 'app-payment-plan-popup',
  templateUrl: './payment-plan-popup.component.html',
  styleUrls: ['./payment-plan-popup.component.scss']
})
export class PaymentPlanPopupComponent {

  tenant: any = localStorage.getItem('tenant')
  cqp_discount = 0;
  constructor(
    public dialogRef: MatDialogRef<PaymentPlanPopupComponent>,
    public helperService: HelperService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any) {
      //console.log(props?.item);

      this.tenant = localStorage.getItem('tenant')

      //this.props.item.orderSummery.cqp_discount  = 2;

      //console.log("prthis.cqp_discountops",this.cqp_discount);


  }
  getPaysVal(val: string) {
    return val.split("")[0] == "." ? `0${val}` : val;
  }

}
